import { useTranslation } from 'react-i18next'
import React from 'react'

import { SmallText, Title } from '../../../components/presentation/Text'
import { useServiceOrder } from './_load/ServiceOrderLoader'
import Separator from '../../../components/helpers/Separator'

const Header = props => {
  const { t } = useTranslation('serviceOrders')
  const serviceOrder = useServiceOrder()

  return (
    <>
      <SmallText>{serviceOrder?.yearlyId}</SmallText>
      <Title size="h5">{t('clone.title')}</Title>
      <SmallText>{t('clone.message', { yearlyId: serviceOrder?.yearlyId })}</SmallText>
      <Separator weight={6} />
    </>
  )
}

export default Header
